const personaPages = (gsap, mm, ScrollTrigger, smoother, imagesLoaded, Swiper, Parallax, Navigation, Pagination, FreeMode) => {
	
	/***************************************************************
		PARALLAX ITEMS
	***************************************************************/
 
		const $container = $('.persona-interview-process');

		const $offices = $('.comp__locations .location');
	
		$offices.each(function(index, el) {
			smoother.effects(el, {lag: 0.3 + index * 0.1});
		});

		let personaPhase = 0;
		const numPersonaPhases = $('.persona-interview-process-steps .accordion-box').length - 0.001;
		$($('.persona-interview-process-steps .accordion-btn')[0]).trigger('click');
		function handlePersonaScroll(progress) {
			const newPhase = Math.floor(progress * numPersonaPhases);

			if (newPhase !== personaPhase) {
				personaPhase = newPhase;
				gsap.to('.interview-steps', {y: ($($('.interview-steps .accordion-box')[newPhase]).height() + 8) * newPhase * -1});
				$($('.persona-interview-process-steps .accordion-btn')[newPhase]).trigger('click');
			}
		}
		

		
		/***************************************************************
			HIRING BLOCK
		***************************************************************/
	 
		openPositions(gsap);
			
	}
	
	export {
		personaPages
	};
	
